import api from '../api'
import {fetchMeta} from './meta'
import { EventTypes } from 'redux-segment' 
import {fetchService} from './service'
import {fetchSections} from './sections'
import {fetchFolders} from './library/folders'
import {refetchSets} from './library/sets'
import {refetchQuestions} from './library/questions'
import store from '../store'
import * as Sentry from '@sentry/browser'


export function fetchUserByUsername(username) {
	const state = store.getState()
	if(state.requestedUserProfiles[username]){
		 return({ type: 'WAIT_TO_REFRESH'})

	}
	else{
  	return (dispatch) => {
 	  dispatch({ type: 'FETCH_USER_PROFILE_REQUEST',username})
  		
  	return api.fetch(`/users?username=${username}`)
	    .then((response) => {
	   
		      dispatch({ type: 'FETCH_USER_PROFILE_SUCCESS',response})
		      return response
	    })
	     .catch(err => {})

	 }
	}
}

export function refetchUserByUsername(username) {
  	return (dispatch) => api.fetch(`/users?username=${username}`)
	    .then((response) => {
		      dispatch({ type: 'FETCH_USER_PROFILE_SUCCESS',response})
		      return response
	    })
	     .catch(err => {})

}






export function fetchUser(currentUserId) {
	return (dispatch) => api.fetch(`/users/${currentUserId}`)
		.then((response) => {
			dispatch({ 
				type: 'FETCH_USER_SUCCESS', 
				response,
				meta:{ 
					analytics: {
	          eventType: EventTypes.identify,
	          eventPayload: {
	            userId: response.id,
              traits: {
                userCreated: response.userCreated,
                email: response.email,
                id: response.id
              }
            } 
          }}})
		})
		.catch((error) => {})
} 

export function fetchUserSignInMethods(currentUserId) {
	return (dispatch) => api.fetch(`/users/${currentUserId}/signin-methods`)
		.then((response) => {
			dispatch({ type: 'FETCH_USER_SIGNIN_METHODS_SUCCESS', response })
			return response
		})
		.catch((error) => {})
}



export function addGoogleSignin(currentUserId,data) {
	return (dispatch) => api.put(`/users/${currentUserId}/add-google-id`,data)
		.then((response) => {
			dispatch({ type: 'ADD_GOOGLE_SIGNIN_SUCCESS', response })
			dispatch(fetchMeta())
			return response
		})

}
 

export function updateGoogleSignin(currentUserId,data,logOut) {
	return (dispatch) => api.put(`/users/${currentUserId}/update-google-id?logOut=${logOut}`,data)
		.then((response) => {
			dispatch({ type: 'UPDATE_GOOGLE_SIGNIN_SUCCESS', response })
			dispatch(fetchUser(currentUserId)) 
			dispatch(fetchMeta())
			dispatch(fetchService())
			return response
		})

}






export function addPassword(currentUserId,data) {
	return (dispatch) => api.put(`/users/${currentUserId}/add-password`,data)
		.then((response) => {
			dispatch({ type: 'ADD_PASSWORD_SUCCESS', response })
			return response
		})
		// .catch((error) => {
		// 	return error
		// })
}


export function removeGoogleSignin(currentUserId,data,logOut) {
	return (dispatch) => api.put(`/users/${currentUserId}/remove-google-id?logOut=${logOut}`,data)
		.then((response) => {
			dispatch({ type: 'REMOVE_GOOGLE_SIGNIN_SUCCESS', response })
	
			dispatch(fetchMeta())
			 dispatch(fetchService())

			 //for isbe (clean up)
			dispatch(fetchSections())
			dispatch(fetchFolders())
			dispatch(refetchSets())
			dispatch(refetchQuestions())


			return response
		})

}



export function resendEmailConfirmation(currentUserId) {
	return (dispatch) => api.put(`/users/${currentUserId}/resend-email-confirmation`).then((response) => {
		return response
	})
}

export function emailAppLinks(currentUserId) {
	return (dispatch) => api.put(`/users/${currentUserId}/email-app-links`).then((response) => {
		return response
	})
}

export function updateUser(data,userId) {
	
  	return (dispatch) => api.put(`/users/${userId}`,data)
	    .then((response) => {
		      dispatch({ type: 'UPDATE_USER_SUCCESS', response,syncAction:true})
		      if(response.username){
		      	 dispatch(refetchUserByUsername(response.username))
		      }

		      return response
	    })
		.catch((error) => {
			   Sentry.withScope(scope => {
				scope.setExtra('request', data)
				Sentry.captureException(new Error('Update user error'))
			})
			throw error
		})
	     
} 


export function updateUserEmail(data,userId) {
	return (dispatch) => api.put(`/users/${userId}/update-email`,data)
		.then((response) => {
			dispatch({ type: 'UPDATE_USER_SUCCESS', response,syncAction:true})
			dispatch(fetchMeta())
			return response
		})
		// .catch((error) => {
		// 	return error
		// })
}

export function updateUserPayoutDestination(data,userId) {
	return (dispatch) => api.put(`/users/${userId}/payoutDestination`,data)
		.then((response) => {
			dispatch({ type: 'UPDATE_USER_SUCCESS', response,syncAction:true})
			dispatch(fetchMeta())
			return response
		})
		// .catch((error) => {
		// 	return error
		// })
}




export function updateUserPassword(data,userId,logOut) {
	return (dispatch) => api.put(`/users/${userId}/update-password?logOut=${logOut}`,data)
		.then((response) => {
			dispatch({ type: 'UPDATE_USER_SUCCESS', response,syncAction:true})
			return response
		})
		// .catch((error) => {

		// 	return error
		// })
     
}

export function forgotPassword(emailAddress,recaptcha) {
	return (dispatch) => api.put(`/users/forgot-password?email=${encodeURIComponent(emailAddress)}`,{recaptchaResponse:recaptcha})
		.then((response) => {
			return response
		})
		.catch(error => {
			if(error.response && error.response.status ===400){
				Sentry.withScope(scope => {
					scope.setExtra('email', emailAddress)
					scope.setExtra('recaptcha', recaptcha)
					Sentry.captureException(new Error('Forgot Password 400 Error'))
				})
			}
				throw error
			})
}

export function resetPassword(userId,data) {
	return (dispatch) => api.put(`/users/${userId}/reset-password`,data)
		.then((response) => {
			return response
		})
}

export function confirmEmailWithIdentity(userId,identity) {
	return (dispatch) => api.put(`/users/${userId}/confirm-email-with-identity`,{identity:identity})
		.then((response) => {
			return response
		})
}


export function confirmEmail(userId,token) {

	return (dispatch) => api.put(`/users/${userId}/confirm-email`,{token:token})
		.then((response) => {
			return response
		})
		.catch((error) => {
			throw error
		})
}

export function testUsername(username) {
	return (dispatch) => api.fetch(`/users?username=${username}`)
		.then((response) => {
			return response
		})
		// .catch((error) => {
		// 	throw error
		// })
}







